import { currentUrl } from '@avensia/excite';

const URL_PARAM_CLEAN = 'clean';

export const ContentKeys = {
  TopContent: 'topContent',
  TopSubNavigationArea: 'topSubNavigationArea',
  TopImage: 'topImage',
  BottomSubNavigationArea: 'bottomSubNavigationArea',
  AdditionalContentDescription: 'additionalContentDescription',
};

export function isContentCleaned(contentKey: string): boolean {
  const cleanParam = Number(currentUrl().searchParams.get(URL_PARAM_CLEAN) ?? '0');
  if (isNaN(cleanParam)) {
    return false;
  }

  if (cleanParam >= 1 && cleanParam <= 5 && contentKey === ContentKeys.TopContent) {
    return true;
  }

  if (cleanParam >= 2 && cleanParam <= 5 && contentKey === ContentKeys.TopSubNavigationArea) {
    return true;
  }

  if (cleanParam >= 3 && cleanParam <= 5 && contentKey === ContentKeys.TopImage) {
    return true;
  }

  if (cleanParam >= 4 && cleanParam <= 5 && contentKey === ContentKeys.BottomSubNavigationArea) {
    return true;
  }

  if (cleanParam === 5 && contentKey === ContentKeys.AdditionalContentDescription) {
    return true;
  }

  return false;
}
